export enum GCBErrorCode {
  INSUFFICIENT_PERMISSIONS = 'INSUFFICIENT_PERMISSIONS',
  INVALID_REQUEST = 'INVALID_REQUEST',
  CONFLICT = 'CONFLICT',
  FORBIDDEN = 'FORBIDDEN',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export class GCBError extends Error {
  constructor(
    message: string,
    public readonly errorCode: GCBErrorCode,
    public readonly statusCode: number,
    public readonly details?: string,
  ) {
    super(message);
    this.name = 'GCBError';
  }

  toResponse() {
    return {
      error: {
        message: this.message,
        details: this.details,
      },
      errorCode: this.errorCode,
    };
  }
}
